import { Button } from "@mui/material";
import { orange } from "@mui/material/colors";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { NavItem } from "../Common/NavItem";

type MenuItemProps = {
  item: NavItem;
  imgLight: boolean;
  onClick: (item: NavItem) => void;
};
const MenuItem = ({ item, imgLight, onClick }: MenuItemProps) => {
  const { t } = useTranslation();

  return (
    <Button
      onClick={() => onClick(item)}
      variant={item.idnm === "booking" ? "contained" : "text"}
      sx={{
        whiteSpace: "nowrap",
        my: 2,
        color: imgLight || item.idnm === "booking" ? "white" : "#343a40",
        display: "block",
        backgroundColor: item.idnm === "booking" ? orange[600] : "",
        "&:hover": {
          backgroundColor: item.idnm === "booking" ? orange[800] : "",
        },
      }}
    >
      {t(item.navheading)}
    </Button>
  );
};

export default MenuItem;
